module.exports = __webpack_public_path__ + "img/training_ma.dbece4ce.jpg";